import React, { useState, useEffect } from "react";

const Footer = () => {
  const [year, setYear] = useState("");
  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);
  return (
    <>
      <div className="w-full py-9 px-[30px] md:px-[70px]  bg-black font-myfont text-white">
        <h3 className=" uppercase font-[10px] leading-3 tracking-wide">
          Join Our Community
        </h3>
        <div className="grid grid-cols-1  mt-[4em] md:grid-cols-2 md:gap-7 ">
          <div className=" flex flex-col">
            <input
              className="w-full md:py-3 py-2 md:px-4 px-3 outline-0  bg-transparent border-[2px] border-white rounded-sm font-medium"
              type="text"
              placeholder="Your Email"
            />
            <br />
            <button className="w-full bg-white text-black md:py-3 py-2 rounded-sm uppercase text-[16px] tracking-wide">
              Subscribe
            </button>
          </div>
          <div className="mt-8  md:justify-center md:items-start">
            <h3 className="uppercase md:-mt-10 md:text-[14px] text-[13px] md:text-center">
              Our Social Media
            </h3>
            <div className="flex md:justify-center md:items-center mt-[3em]">
              <span className="px-2 cursor-pointer">
                <svg
                  className="md:w-8 md:h-8 w-5 h-5"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M39.375 20C39.375 9.29688 30.7031 0.625 20 0.625C9.29688 0.625 0.625 9.29688 0.625 20C0.625 29.6703 7.71016 37.6859 16.9727 39.1406V25.6008H12.0508V20H16.9727V15.7313C16.9727 10.8758 19.8633 8.19375 24.2906 8.19375C26.4109 8.19375 28.6281 8.57188 28.6281 8.57188V13.3375H26.1844C23.7781 13.3375 23.0273 14.8312 23.0273 16.3633V20H28.4008L27.5414 25.6008H23.0273V39.1406C32.2898 37.6859 39.375 29.6703 39.375 20Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span className="px-2 cursor-pointer">
                <svg
                  className="md:w-8 md:h-8 w-5 h-5"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35 2.5H4.99219C3.61719 2.5 2.5 3.63281 2.5 5.02344V34.9766C2.5 36.3672 3.61719 37.5 4.99219 37.5H35C36.375 37.5 37.5 36.3672 37.5 34.9766V5.02344C37.5 3.63281 36.375 2.5 35 2.5ZM13.0781 32.5H7.89062V15.7969H13.0859V32.5H13.0781ZM10.4844 13.5156C8.82031 13.5156 7.47656 12.1641 7.47656 10.5078C7.47656 8.85156 8.82031 7.5 10.4844 7.5C12.1406 7.5 13.4922 8.85156 13.4922 10.5078C13.4922 12.1719 12.1484 13.5156 10.4844 13.5156ZM32.5234 32.5H27.3359V24.375C27.3359 22.4375 27.2969 19.9453 24.6406 19.9453C21.9375 19.9453 21.5234 22.0547 21.5234 24.2344V32.5H16.3359V15.7969H21.3125V18.0781H21.3828C22.0781 16.7656 23.7734 15.3828 26.2969 15.3828C31.5469 15.3828 32.5234 18.8438 32.5234 23.3438V32.5Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span className="px-2 cursor-pointer">
                <svg
                  className="md:w-8 md:h-8 w-5 h-5"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.0045 9.81492C14.3291 9.81492 9.75125 14.4268 9.75125 20.1445C9.75125 25.8622 14.3291 30.4741 20.0045 30.4741C25.6799 30.4741 30.2577 25.8622 30.2577 20.1445C30.2577 14.4268 25.6799 9.81492 20.0045 9.81492ZM20.0045 26.8601C16.3369 26.8601 13.3385 23.8484 13.3385 20.1445C13.3385 16.4406 16.3279 13.4289 20.0045 13.4289C23.681 13.4289 26.6704 16.4406 26.6704 20.1445C26.6704 23.8484 23.6721 26.8601 20.0045 26.8601ZM33.0686 9.39239C33.0686 10.7319 31.9978 11.8017 30.6771 11.8017C29.3475 11.8017 28.2856 10.7229 28.2856 9.39239C28.2856 8.06186 29.3564 6.98305 30.6771 6.98305C31.9978 6.98305 33.0686 8.06186 33.0686 9.39239ZM39.8595 11.8377C39.7078 8.61025 38.976 5.75141 36.6291 3.396C34.2911 1.0406 31.4534 0.303415 28.2499 0.141594C24.9481 -0.0471979 15.0519 -0.0471979 11.7501 0.141594C8.55549 0.294425 5.71779 1.03161 3.37089 3.38701C1.02398 5.74242 0.301171 8.60126 0.140547 11.8287C-0.0468489 15.155 -0.0468489 25.125 0.140547 28.4514C0.292248 31.6788 1.02398 34.5377 3.37089 36.8931C5.71779 39.2485 8.54657 39.9856 11.7501 40.1475C15.0519 40.3363 24.9481 40.3363 28.2499 40.1475C31.4534 39.9946 34.2911 39.2575 36.6291 36.8931C38.9671 34.5377 39.6988 31.6788 39.8595 28.4514C40.0469 25.125 40.0469 15.164 39.8595 11.8377ZM35.594 32.0204C34.8979 33.7825 33.5505 35.14 31.7925 35.8502C29.1601 36.9021 22.9136 36.6593 20.0045 36.6593C17.0954 36.6593 10.8399 36.8931 8.2164 35.8502C6.46737 35.149 5.11991 33.7915 4.41495 32.0204C3.37089 29.3684 3.61182 23.0753 3.61182 20.1445C3.61182 17.2138 3.37981 10.9117 4.41495 8.26863C5.11099 6.50657 6.45845 5.14907 8.2164 4.43885C10.8489 3.38701 17.0954 3.62975 20.0045 3.62975C22.9136 3.62975 29.169 3.396 31.7925 4.43885C33.5416 5.14008 34.889 6.49758 35.594 8.26863C36.638 10.9207 36.3971 17.2138 36.3971 20.1445C36.3971 23.0753 36.638 29.3773 35.594 32.0204Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div className="mt-[7em] flex justify-center items-center text-[14px]">
          <h2>
            Ecommerce Team <span>{year}</span>© All Rights Reserved
          </h2>
        </div>
      </div>
    </>
  );
};

export default Footer;
